const getFileExt = (fileType) => {
    const extIndex = fileType.lastIndexOf('/') + 1;
    return fileType.substr(extIndex).split('.')[0];
  };
  export default getFileExt;